import data from "../../shared/data";

export async function setUser({ commit }, user) {
  commit("setUser", user);
}

export async function getArticles() {
  const result = await data.get("/api/Products");

  //commit("SET_ARTICLE", result);
  return result;
}

export async function getArticle(x, productId) {
  const result = await data.get("/api/Products/" + productId);

  return result;
}

export async function putArticle(x, payload) {
  const result = await data.put(
    "/api/Products/" + payload.internalID,
    payload.productDto
  );

  return JSON.parse(result);
}

export async function postArticle(x, payload) {
  const result = await data.post("/api/Products", payload);

  return JSON.parse(result);
}

export async function getStocks() {
  const result = await data.get("/api/Stock");

  //commit("SET_ARTICLE", result);
  return result;
}
export async function getStocksIncludeEmpty() {
  const result = await data.get("/api/Stock?includeEmptyStock=true");

  //commit("SET_ARTICLE", result);
  return result;
}

export async function getStockTransactions() {
  const result = await data.get("/api/StockTransaction");

  return result;
}

export async function postStock(x, payload) {
  const result = await data.post("/api/Stock/CreateOrUpdate", payload);

  return JSON.parse(result);
}

export async function moveStock(x, payload) {
  const result = await data.post("/api/Stock/Move", payload);

  return JSON.parse(result);
}

export async function getVatType({ commit }) {
  const result = await data.get("/api/VatType");

  commit("setVatTypes", result);
  return result;
}

export async function getAccount({ commit }) {
  const result = await data.get("/api/Account");

  commit("setAccounts", result);
  return result;
}

export async function getProject({ commit }) {
  const result = await data.get("/api/Project");

  commit("setProjects", result);
  return result;
}
export async function getDepartment({ commit }) {
  const result = await data.get("/api/Department");

  commit("setDepartments", result);
  return result;
}

export async function getWarehouse({ commit }) {
  const result = await data.get("/api/Warehouse");

  commit("setWarehouses", result);
  return result;
}

export async function getLocation({ commit }) {
  const result = await data.get("/api/Location");

  commit("setLocations", result);
  return result;
}

export async function getOrders() {
  const result = await data.get("/api/CustomerOrder");

  return result;
}

export async function getOrdersByStatuses(x, statuses) {
  var url = "/api/CustomerOrder/";
  if (statuses != undefined && statuses.length > 0) {
    var queryString = "?status=";
    queryString += statuses.join("&status=");
    url = url + queryString;
  }

  const result = await data.get(url);

  return result;
}

export async function postCustomerOrderItemTransaction(x, payload) {
  const result = await data.post("/api/CustomerOrderItemTransaction", payload);

  return JSON.parse(result);
}

export async function deleteCustomerOrderItemTransaction(x, id) {
  const result = await data.delete("/api/CustomerOrderItemTransaction/" + id);

  return result;
}

export async function deletePurchaseOrderItemTransaction(x, id) {
  const result = await data.delete("/api/PurchaseOrderItemTransaction/" + id);

  return result;
}

export async function getCustomerOrderItemTransactions(x, orderId) {
  const result = await data.get(
    "/api/CustomerOrderItemTransaction/GetByCustomerOrderId/" + orderId
  );

  return result;
}
export async function getCustomerOrderPackage(x, orderId) {
  const result = await data.get(
    "/api/CustomerOrderPackage/GetByCustomerOrderId/" + orderId
  );

  return result;
}

export async function postCustomerOrderPackage(x, payload) {
  const result = await data.post("/api/CustomerOrderPackage", payload);

  return JSON.parse(result);
}

export async function getSalesOrder(x, orderId) {
  const result = await data.get("/api/CustomerOrder/" + orderId);

  return result;
}

export async function getDimensions({ commit }) {
  const result = await data.get("/api/Dimensions");

  commit("setDimensions", result);
  return result;
}

export async function getDimensionSettings({ commit }) {
  const result = await data.get("/api/DimensionSettings");

  commit("setDimensionSettings", result);
  return result;
}

export async function getSettings({ commit }) {
  const result = await data.get("/api/Settings");

  commit("setSettings", result);
  return result;
}

export async function updateSettings(x, payload) {
  const result = await data.put("/api/Settings", payload);
  //commit("setSettings", result);

  return JSON.parse(result);
}

export async function getPackingSlipReport(x, packageId) {
  const result = await data.getFile("/api/Report/PackingSlip/" + packageId);

  return result;
}

export async function getPurchaseOrderReport(x, orderId) {
  const result = await data.getFile("/api/Report/PurchaseOrder/" + orderId);

  return result;
}

export async function getPurchaseOrders() {
  const result = await data.get("/api/PurchaseOrder");

  return result;
}

export async function getPurchaseOrdersByStatuses(x, statuses) {
  var url = "/api/PurchaseOrder";
  if (statuses != undefined && statuses.length > 0) {
    var queryString = "?status=";
    queryString += statuses.join("&status=");
    url = url + queryString;
  }

  const result = await data.get(url);

  return result;
}

export async function getPurchaseOrder(x, orderId) {
  const result = await data.get("/api/PurchaseOrder/" + orderId);

  return result;
}

export async function postPurchaseOrderItemTransaction(x, payload) {
  const result = await data.post("/api/PurchaseOrderItemTransaction", payload);

  return JSON.parse(result);
}

export async function getCurrencies({ commit }) {
  const result = await data.get("/api/Currency/CurrencyCodes");

  commit("setCurrencies", result);
  return result;
}

export async function getExchangeRate(x, id) {
  const result = await data.get("/api/Currency/ExchangeRate/" + id);

  return result;
}

export async function getSuppliers({ commit }) {
  const result = await data.get("/api/Supplier");

  commit("setSuppliers", result);
  return result;
}

export async function postPurchaseOrder(x, payload) {
  const result = await data.post("/api/PurchaseOrder", payload);

  return JSON.parse(result);
}
export async function putPurchaseOrder(x, payload) {
  const result = await data.put(
    "/api/PurchaseOrder/" + payload.id,
    payload.purchaseDto
  );

  return JSON.parse(result);
}

export async function deletePurchaseOrder(x, id) {
  const result = await data.delete("/api/PurchaseOrder/" + id);

  return result;
}

export async function getSuggestedOrderItemsBySupplier(x, supplierId) {
  const result = await data.get(
    "/api/PurchaseOrderItem/SuggestedOrderItems/" + supplierId
  );

  return result;
}

export async function getSuggestedOrderItems() {
  const result = await data.get("/api/PurchaseOrderItem/SuggestedOrderItems");

  return result;
}

export async function postPurchaseOrderFromOrderItems(x, payload) {
  const result = await data.post(
    "/api/PurchaseOrder/PurchaseOrdersFromOrderItems",
    payload
  );

  return JSON.parse(result);
}

export async function getCountings() {
  const result = await data.get("/api/Counting");

  return result;
}
export async function getCounting(x, id) {
  const result = await data.get("/api/Counting/" + id);

  return result;
}

export async function postCounting(x, name) {
  const result = await data.post("/api/Counting", name);

  return JSON.parse(result);
}

export async function getCountingStocks() {
  const result = await data.get("/api/CountingStock");

  return result;
}

export async function getCountingStock(x, id) {
  const result = await data.get("/api/CountingStock/" + id);

  return result;
}

export async function postCountingStocks(x, payload) {
  const id = payload[0].countingId;

  const result = await data.post(
    "/api/CountingStock/UpdateByCountingId/" + id,
    payload
  );

  return JSON.parse(result);
}

export async function postCountingComplete(x, id) {
  const result = await data.post("/api/Counting/Complete/" + id);

  return JSON.parse(result);
}

export async function postCountingCancel(x, id) {
  const result = await data.post("/api/Counting/Cancel/" + id);

  return JSON.parse(result);
}

export async function putWarehouse(x, payload) {
  const result = await data.put("/api/Warehouse/" + payload.id, payload);

  return JSON.parse(result);
}
export async function postWarehouse(x, payload) {
  const result = await data.post("/api/Warehouse", payload);

  return JSON.parse(result);
}

export async function putLocation(x, payload) {
  const result = await data.put("/api/Location/" + payload.id, payload);

  return JSON.parse(result);
}
export async function postLocation(x, payload) {
  const result = await data.post("/api/Location", payload);

  return JSON.parse(result);
}

export async function postBarcode(x, payload) {
  const result = await data.post("/api/Barcode", payload);

  return JSON.parse(result);
}

export async function putBarcode(x, payload) {
  const result = await data.put("/api/Barcode/" + payload.id, payload);

  return JSON.parse(result);
}

export async function deleteBarcode(x, id) {
  const result = await data.delete("/api/Barcode/" + id);

  return result;
}

export async function getBarcodesByProductId(x, id) {
  const result = await data.get(
    "/api/Barcode/GetByProductId/" + id
  );

  return result;
}
